module.exports = __webpack_public_path__ + "img/egg-7.6a9a4dd9.png";